import { createFileRoute } from "@tanstack/react-router";

import { PLANS_QUERY } from "@/features/settings/plans/graphql/plans-query";
import { Plans } from "@/features/settings/plans/plans";

export const Route = createFileRoute("/_authenticated/settings/plans/")({
  component: Plans,
  loader: async ({ context }) => {
    if (context.urqlClient) {
      await context.urqlClient.query(PLANS_QUERY, {}).toPromise();
    }
  },
});
